import { createSlice } from "@reduxjs/toolkit";
import {getLocations} from '../reduxApi/locationReduxApi';

const locationSlice = createSlice({
    name: 'location',
    initialState: {
        status: 'idel',
        location: [],
    },
    reducers: {
        deleteLocationAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.location.findIndex((item) => item.locations.ROWID === id);
                if (index !== -1) {
                    state.location.splice(index, 1);
                }
            });
        },
        updateLocationAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.location.findIndex((item) => item.locations.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.location.splice(index, 1, { locations: action.payload })
            }
        },
        addLocationAction: (state, action) => {
            console.log("Adding location:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.location.unshift({locations:temp});
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getLocations.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getLocations.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing location Data", action.payload)
                state.location = action.payload.data.response
;
            })
    }
})
export const { deleteLocationAction, updateLocationAction, addLocationAction } = locationSlice.actions
export default locationSlice.reducer